export default __webpack_public_path__ + "static/media/guia-3-4.e9ab2a07.svg";